export const getParentElement = (el) => {
  if (!el.parentElement) {
    const rootNodeEl = el.getRootNode();
    if (rootNodeEl.host) {
      // Shadow root is the parent
      return { el: rootNodeEl.host, fromShadowRoot: true };
    }
    throw new Error('Parent element not found.');
  }
  return { el: el.parentElement };
};
export const closestElement = (selector, el = this) => {
  if (!el)
    return null;
  return (el && el != document && el != window && el.closest(selector)) || closestElement(selector, el.getRootNode().host);
};
